import React from 'react';

const HeaderNews = () => (
  <div style={{ marginBottom: '1.2rem', textAlign: 'left' }}>
    <h2 style={{ color: '#1976d2', fontSize: '1.2rem', fontWeight: 700, margin: 0 }}> News & Updates</h2>
    {/* Advertisement Header with 4 sample ads */}
    <>
      <style>{`
        @media (max-width: 600px) {
          .news-ads-header { grid-template-columns: repeat(3, 1fr) !important; }
        }
      `}</style>
      <div className="news-ads-header" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(6, 1fr)',
        gap: '6px',
        marginBottom: '18px',
      }}>
      {[
        {
          id: 1,
          img: '/images/realimages/1_mangalore_kankanady_a1.jpg',
          link: 'https://property.example.com',
          alt: 'Buy/Sell Property in Mangalore',
        },
        {
          id: 2,
          img: '/images/realimages/101_mangalore_kulshekar_a1.jpg',
          link: 'https://gulfjobs.example.com',
          alt: 'Gulf Job Openings',
        },
        {
          id: 3,
          img: '/images/realimages/103_mangalore_bendoor_a1.jpg',
          link: 'https://tourism.example.com',
          alt: 'Coastal Tourism Packages',
        },
        {
          id: 4,
          img: '/images/realimages/4_mangalore_bondel_a1.jpg',
          link: 'https://classifieds.example.com',
          alt: 'Classifieds - Post Your Ad',
        },
        {
          id: 5,
          img: '/images/realimages/100-wellesley-street-east-id617445.jpg',
          link: 'https://education.example.com',
          alt: 'Education & Training',
        },
      ].map(ad => (
  <a href={ad.link} target="_blank" rel="noopener noreferrer" key={ad.id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#f7f7f7', borderRadius: '10px', padding: '10px 0', boxShadow: '0 2px 8px rgba(0,0,0,0.09)', textDecoration: 'none' }}>
          <img src={ad.img} alt={ad.alt} style={{ width: 110, height: 82, objectFit: 'cover', borderRadius: '8px', marginBottom: '8px' }} />
          <span style={{ fontSize: '0.85rem', fontWeight: 500, color: '#333', textAlign: 'center' }}>{ad.alt}</span>
        </a>
      ))}
      </div>
    </>
  </div>
);

export default HeaderNews;
